import React, { useContext } from "react";
import classNames from "classnames";
import { GameContext } from "../../context/GameContext";
import useResponsive from "../../hooks/useResponsive";

import { Trophy } from "../../assets/svg/icons";

const ProgressIndicator = ({ onClick }) => {
  const {
    currentQuestion,
    questionsArray,
    userAnswer,
    numCorrectAnswers,
    deskQuest,
    view,
    isFlipped,
    setIsFlipped,
  } = useContext(GameContext);
  const { Mobile, Default } = useResponsive();

  const checkStatus = (index) => {
    var res;
    if (userAnswer.length > 0) {
      res = userAnswer.find((obj) => {
        return obj.id === index;
      });
    }
    if (!res) {
      return;
    }
    return res.correct;
  };

  const handleClick = (id, e) => {
    if (isFlipped) {
      setIsFlipped(false);
    }
    onClick(id, e);
  };

  const handleKeyPress = (e, obj) => {
    if (e.key === "Enter") handleClick(obj.id, e);
  };

  const styles = {
    paddingBlockEnd: userAnswer.length > 0 && !deskQuest ? "0" : "5.4rem",
  };

  return (
    <div className="progress_container" style={styles}>
      <Default>
        <nav className="steps" aria-label="Navigering frågor">
          <ul>
            {questionsArray.map((obj, index) => {
              return (
                <li key={obj.id}>
                  <button
                    // tabIndex="0"
                    onClick={(e) => {
                      if (view === "game") {
                        handleClick(obj.id, e);
                      }
                    }}
                    onKeyPress={(e) => {
                      if (view === "game") {
                        handleKeyPress(e, obj);
                      }
                    }}
                    aria-current={index === currentQuestion && deskQuest}
                    data-id={obj.id}
                    aria-label={`Fråga nummer ${index + 1}`}
                    className={classNames("step", {
                      current: index === currentQuestion && deskQuest,
                      correct: checkStatus(index) === true,
                      incorrect: checkStatus(index) === false,
                      disable: view !== "game",
                    })}
                  ></button>
                </li>
              );
            })}
          </ul>
        </nav>
      </Default>
      <Mobile>
        <div className="steps">
          {questionsArray.map((obj, index) => {
            return (
              <div
                key={obj.id}
                id={index}
                className={classNames("step mobile", {
                  current: index === currentQuestion,
                  correct: checkStatus(index) === true,
                  incorrect: checkStatus(index) === false,
                })}
              ></div>
            );
          })}
        </div>
      </Mobile>

      <div className="steps_column">
        <Trophy className="trophy_small" />
        <span className="display_numbers">
          {numCorrectAnswers} / {questionsArray.length}
        </span>
      </div>
    </div>
  );
};

export default ProgressIndicator;
